import { breakpoints } from "@repo/fika-design-system/breakpoints"
import type { AccentHue } from "@repo/fika-design-system/color"
import { createMemo, type ParentProps } from "solid-js"
import { Box } from "@/designSystem/components/box"
import { Text } from "@/designSystem/components/text"
import {
  imageClass,
  sectionDescriptionRecipe,
  sectionRecipe,
  sectionTitleRecipe,
  textClass,
  titleClass,
} from "./onboarding.css"

const CDN_ASSETS_URL = import.meta.env.VITE_CDN_ASSETS_URL
const FOLDER = "static"

type SectionProps = ParentProps & {
  href?: string
  hue: AccentHue
  title: string
  description: string
  img: "stories" | "publication" | "rabbit" | "pen"
}
function Section(props: SectionProps) {
  const imgUrl = createMemo(
    () => `${CDN_ASSETS_URL}/${FOLDER}/${props.img}.png`,
  )

  return (
    <a href={props.href} class={sectionRecipe({ hue: props.hue })}>
      <img
        srcset={`
                    ${imgUrl()}?width=96 96w,
                    ${imgUrl()}?width=64 64w,
                    ${imgUrl()}?width=48 48w,
                    ${imgUrl()}?width=32 40w,
                `}
        sizes={`
                    ${breakpoints.xs} 32px,
                    ${breakpoints.s} 40px,
                    48px
                `}
        class={imageClass}
        alt={props.title}
      />
      <Box>
        <Text class={sectionTitleRecipe({ hue: props.hue })}>
          {props.title}
        </Text>
        <Text
          class={sectionDescriptionRecipe({
            hue: props.hue,
          })}
        >
          {props.description}
        </Text>
      </Box>
    </a>
  )
}

export function Onboarding() {
  return (
    <Box fill gap="16">
      <Box padding="24" alignItems="center" class={titleClass}>
        <Text
          fontSize="hero1"
          textAlign="center"
          color="sand900"
          fontWeight="800"
          fontFamily="accent"
          class={textClass}
        >
          welcome to fika!
        </Text>
        <Text fontSize="h3" textAlign="center" color="sand800">
          a place to read, write and discover stories
        </Text>
      </Box>
      <Section
        href="/bookmarks/all"
        title="bookmark stories"
        hue="emerald"
        img="stories"
        description={`
                    save any cool stuff you find online, whether it's an
                    interesting article, a helpful blog post, or
                    something you want to read later.
                `}
      />
      <Section
        href="/feeds/subscriptions"
        title="subscribe to feeds"
        hue="indigo"
        img="publication"
        description={`
                    fika suggests blogs and newsletters based on the stories
                    you bookmark, so you can subscribe to them and stay updated
                    with their latest content.
                `}
      />
      <Section
        href="/blog/published"
        title="create your own blog"
        hue="amber"
        img="pen"
        description={`
                    along with sharing bookmarked stories, you can also create blog posts on fika and let others follow your personal feed.
                `}
      />
    </Box>
  )
}
